import { render, staticRenderFns } from "./ReportScoreDetailed.vue?vue&type=template&id=bc4a4b72"
import script from "./ReportScoreDetailed.vue?vue&type=script&lang=js"
export * from "./ReportScoreDetailed.vue?vue&type=script&lang=js"
import style0 from "./ReportScoreDetailed.vue?vue&type=style&index=0&id=bc4a4b72&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports